import { Button, Card, CardBody, CardHeader } from '@material-tailwind/react';
import TextWinds from '../../../components/common/TextWinds';
import {
  ClassBookItem,
  LastTeachingBookItem,
} from '../../../constants/types/lms/take-class/type';

interface BookListCardProps {
  book: ClassBookItem;
  lastTeachingBook: LastTeachingBookItem;
  onBookClick: (bookCode: string) => void;
}

/**
 * 개편 LMS (교사) - 수업하기 페이지 > 북 목록 판넬 > 북 카드
 */
const BookListCard = ({
  book,
  lastTeachingBook,
  onBookClick,
}: BookListCardProps) => {
  const isRecentlyViewed = book.bookCode === lastTeachingBook?.bookCode;

  return (
    <Card
      key={book.bookCode}
      className={[
        'relative overflow-hidden shadow-card transition-all',
        isRecentlyViewed
          ? 'ring-2 ring-purple5 ring-offset-2 ring-offset-white'
          : '',
      ].join(' ')}
    >
      {isRecentlyViewed && (
        <div className="absolute left-2 top-2 z-10 flex items-center gap-1.5 rounded-full bg-purple5 px-2 py-1 shadow-md">
          <span className="h-1.5 w-1.5 rounded-full bg-white" />

          <TextWinds type="caption1" color="white">
            최근 열람
          </TextWinds>
        </div>
      )}

      <Button
        className={[
          'flex h-full w-full flex-col items-stretch rounded-xl border bg-white p-0 shadow-none transition-colors',
          isRecentlyViewed
            ? 'border-purple5 hover:border-purple6'
            : 'border-gray2 hover:border-purple2',
        ].join(' ')}
        onClick={() => onBookClick(book.bookCode)}
      >
        <CardHeader className="m-0 aspect-square w-full shrink-0 rounded-none rounded-t-xl p-0 shadow-none">
          <img
            className="block h-full w-full object-cover"
            src={book.imageUrl}
            alt={book.bookCode}
          />
        </CardHeader>

        <CardBody className="px-3 py-4">
          <div className="flex min-w-0 flex-col items-start text-left">
            <div className="min-h-[44px] w-full">
              <TextWinds
                type="content_body2"
                className="line-clamp-2 w-full text-left font-bold leading-tight"
              >
                {book.bookCode}
              </TextWinds>
            </div>

            <TextWinds
              type="caption1"
              color="gray8"
              className="mt-1 w-full text-left"
            >
              {book.lessonRange}
            </TextWinds>
          </div>
        </CardBody>
      </Button>
    </Card>
  );
};

export default BookListCard;
